import { createReducer } from '@reduxjs/toolkit';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import actions from './actions';
import constants from './constants';

interface SwitchAppVersionState {
  readonly currentPage: number;
  readonly files: appStorageRecords.AppStorageFile[];
  readonly hasDataFetched: boolean;
  readonly isLoading: boolean;
  readonly itemsPerPage: number;
  readonly searchQuery: string;
  readonly totalItems: number;
}

const initialState: SwitchAppVersionState = {
  currentPage: 1,
  files: [],
  hasDataFetched: false,
  isLoading: false,
  itemsPerPage: constants.FETCH_FILES_PAGE_SIZE,
  searchQuery: '',
  totalItems: 0,
};

const switchAppVersionReducer = createReducer(initialState, (builder) => {
  // fetchAppStorageFiles
  builder.addCase(actions.fetchAppStorageFiles.pending, (draft, { meta }) => {
    draft.isLoading = true;
    draft.searchQuery = meta.arg?.searchQuery ?? draft.searchQuery;
  });

  builder.addCase(actions.fetchAppStorageFiles.fulfilled, (draft, { payload }) => {
    draft.currentPage = payload.page;
    draft.files = payload.items;
    draft.hasDataFetched = true;
    draft.isLoading = false;
    draft.totalItems = payload.total_items;
  });

  builder.addCase(actions.fetchAppStorageFiles.rejected, (draft) => {
    draft.hasDataFetched = true;
    draft.isLoading = false;
  });

  builder.addCase(actions.reset, () => initialState);
});

export default switchAppVersionReducer;
export {
  initialState,
  SwitchAppVersionState,
};
